<div *ngIf="isPrescription" class="mt-prescription-notification">
  You are typing a prescription
</div>

<div class="mt-chat-input">
  <textarea
    class='mt-message-input'
    [(ngModel)]="textPayload"
    (keydown)="handleKeyDown($event)"
    rows='1'
    placeholder='Type your message here'
  >
  </textarea>

  <div class="mt-icon-precription" *ngIf="isDoctor" (click)="togglePrescription()">
    <mitter-prescription-on-icon *ngIf="isPrescription; else offIcon">
    </mitter-prescription-on-icon>
  </div>

  <ng-template #offIcon>
    <mitter-prescription-off-icon></mitter-prescription-off-icon>
  </ng-template>

  <div class="mt-icon-camera" (click)="openImageForm()">
    <mitter-camera-icon></mitter-camera-icon>
  </div>

  <div class="mt-icon-send" (click)="sendTextMessage(textPayload)">
    <mitter-send-icon></mitter-send-icon>
  </div>
</div>
